import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-689f3da3"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["checked", "onChange", "value", "name"]
const _hoisted_2 = {
  key: 0,
  class: "switch-item--text"
}
const _hoisted_3 = {
  key: 1,
  class: "switch-item--text"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["switch-wrapper", `switch-wrapper-${$setup.props.theme}`]),
    style: _normalizeStyle($setup.cssVars)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.list, (item, index) => {
      return (_openBlock(), _createElementBlock("label", {
        class: _normalizeClass(["switch-item", { 'switch-item-active': item.label === $setup.props.modelValue?.label }]),
        key: index,
        ref_for: true,
        ref: (el) => { if (el) { $setup.switchItems[index] = el; } }
      }, [
        _createElementVNode("input", {
          checked: item.label === $setup.props.modelValue?.label,
          onChange: ($event: any) => ($setup.onChangeItem(item, index)),
          value: item.label,
          type: "radio",
          name: $setup.props.nameRadio
        }, null, 40, _hoisted_1),
        ($setup.props.slots.includes('customSwitch'))
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _renderSlot(_ctx.$slots, "customSwitch", _normalizeProps(_guardReactiveProps(item)), undefined, true)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(item.label), 1))
      ], 2))
    }), 128)),
    _hoisted_4
  ], 6))
}